import { version } from '../../package.json';
import { buildNumber } from './buildNumber';

export const frontendVersionWithBuildNumber = `${version}.${buildNumber}`;
